'use strict';

module.exports = require('./components/TinyMCE');


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-tinymce/lib/main.js
// module id = 74
// module chunks = 0